import {SearchCriteria} from './search-criteria';

export class Metadata {
  column: string;
  field: string;
}
